import VehicleImageWithPlaceholder from './VehicleImageWithPlaceholder';

export default VehicleImageWithPlaceholder;



// WEBPACK FOOTER //
// ./src/components/atoms/VehicleImageWithPlaceholder/index.js